import { useAppSelector } from '@app/redux/hooks';
import { IconInputDelete, IconSearch } from '@koleso-icons';
import classNames from 'classnames';
import { DetailedHTMLProps, InputHTMLAttributes, useCallback, useState } from 'react';

import styles from './InputSearch.module.scss';

interface InputProps extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  onClearInput: () => void;
}

export const InputSearch = ({ value, className, onClearInput, ...props }: InputProps) => {
  const [isFocus, setIsFocus] = useState<boolean>(false);
  const { isIos } = useAppSelector(state => state.header.data.userAgent);
  const handlerOnFocus = useCallback(() => setIsFocus(true), []);

  const handlerOnBlur = useCallback(() => setIsFocus(false), []);

  return (
    <div
      className={classNames(
        styles.Wrapper,
        {
          [styles.focus]: isFocus,
          [styles.IsIos]: isIos,
        },
        className,
      )}
    >
      <input value={value} {...props} onFocus={handlerOnFocus} onBlur={handlerOnBlur} />
      {value ? <IconInputDelete className={styles.ClearInput} onClick={onClearInput} /> : <IconSearch />}
    </div>
  );
};
